

mp-foreground-cookies {
  display: block;
  color: var(--color-font-one);
  padding-bottom: 1em;

  &:first-child {
    padding-top: var(--page-padding-top);
  }

  &:last-child {
    padding-bottom: calc(var(--page-padding-bottom) + 40px);
  }

}
